import Addon from '../../../../shared/classes/addon';
import Card from '../../../../shared/types/props/card';
import TickAddonContainer from '../../atoms/container/tickAddonContainer';
import TickIcon from '../../atoms/icons/tickIcon';
import HorizontalCard from './horizontalCard';

function AddonHorizontalCard({ item, index, onClick, releaseAction }: Card) {
  const checkAddon = (item as Addon).checkAddon && (item as Addon).checkAddon();
  return (
    <HorizontalCard
      key={index}
      index={index}
      item={item}
      showInfo={false}
      showMask={false}
      onClick={onClick}
      releaseAction={releaseAction}
    >
      {checkAddon ? (
        <TickAddonContainer>
          <TickIcon />
        </TickAddonContainer>
      ) : (
        <></>
      )}
    </HorizontalCard>
  );
}

export default AddonHorizontalCard;
